import {
  isGenerationNavigationBlocked,
  requestGenerationExitConfirmation,
} from "../lib/generationNavigationGuardStore";
import { applyHashNavigation } from "./applyHashNavigation";
import { normalizeTemaHash } from "./resolveTemaRoute";

export function navigateToRoute(path) {
  const nextHash = normalizeTemaHash(path);
  const currentHash = normalizeTemaHash(window.location.hash);
  if (currentHash === nextHash) {
    return;
  }

  if (isGenerationNavigationBlocked()) {
    requestGenerationExitConfirmation({
      type: "navigate",
      targetHash: nextHash,
      onNavigate: applyHashNavigation,
    });
    return;
  }

  applyHashNavigation(path);
}

export function buildRouteHref(path) {
  const normalized = normalizeTemaHash(path);
  return normalized === "#" ? "#" : normalized;
}
